import { render, staticRenderFns } from "./imageComponent.vue?vue&type=template&id=1132c04e&scoped=true&"
import script from "./imageComponent.vue?vue&type=script&lang=js&"
export * from "./imageComponent.vue?vue&type=script&lang=js&"
import style0 from "./imageComponent.vue?vue&type=style&index=0&id=1132c04e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132c04e",
  null
  
)

export default component.exports